// src/components/dashboard/Sidebar.jsx
import React, { useMemo } from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { rolesOf } from '../../utils/roles';
import '../../styles/Sidebar.css';

export default function Sidebar() {
  // AuthContext writes the `user` localStorage key asynchronously after
  // /api/me returns. Reading that key once at mount hid staff links from
  // genuine staff on a cold load, with no re-render when the key arrived.
  const { user: authUser } = useAuth();
  const stored = useMemo(() => {
    try { return JSON.parse(localStorage.getItem('user')) || {}; }
    catch { return {}; }
  }, []);
  const user = authUser || stored;

  // rolesOf reads whichever field actually carries the role. `user.role ===`
  // alone is the check src/utils/roles.js warns about: /api/me returns `role`
  // but AuthContext stores `roles`, so the two shapes disagree by source.
  const roles = rolesOf(user);
  const isAdmin = roles.includes('admin');
  const isLeadReviewer = roles.includes('lead_reviewer');

  return (
    <aside className="rv-sidebar">
      <nav className="rv-sidebar__nav" aria-label="Dashboard navigation">
        <NavLink className="rv-sidebar__link" to="/chat">
          Communications
        </NavLink>

        <NavLink className="rv-sidebar__link" to="/library">
          Library
        </NavLink>

        <NavLink className="rv-sidebar__link" to="/settings">
          Settings
        </NavLink>

        <NavLink className="rv-sidebar__link" to="/analytics">
          Analytics
        </NavLink>

        <NavLink className="rv-sidebar__link" to="/community">
          Community
        </NavLink>

        {(isLeadReviewer || isAdmin) && (
          <NavLink className="rv-sidebar__link" data-testid="sidebar-review-queue" to="/review-queue">
            Review Queue
          </NavLink>
        )}

        {(isLeadReviewer || isAdmin) && (
          <NavLink className="rv-sidebar__link" data-testid="sidebar-print-queue" to="/print-queue">
            Print Queue
          </NavLink>
        )}

        {isAdmin && (
          <NavLink className="rv-sidebar__link" to="/admin">
            Admin
          </NavLink>
        )}
      </nav>
    </aside>
  );
}